import { InjectionToken } from '@angular/core';
import { WorldpayConfig } from '../models/worldpay/worldpay-config.interface';

export const WORLDPAY_CONFIG = new InjectionToken<WorldpayConfig>(
  'Worldpay config'
);
